import { setupLayouts } from 'virtual:meta-layouts'
import generatedRoutes from 'virtual:generated-pages'
import type { RouteRecordRaw } from 'vue-router'
import type { Route } from '#/global'
import useSettingsStore from '@/store/modules/settings'

import YearFrame from './modules/year_frame'
import Business from './modules/business'
import Welfare from './modules/welfare'
import CreationCamp from './modules/creation_camp'
import Task from './modules/task'
import MerchantManage from './modules/merchant_manage'
import RegimentalCommander from './modules/regimental_commander'
import Merchant from './modules/merchant'
import Setups from './modules/setups'
import MainBusiness from './modules/main_business'



// 固定路由（默认路由）
const constantRoutes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login.vue'),
    meta: {
      title: '登录',
    },
    children: [
        {
            path: ':code',
            name: 'logins',
            component: () => import('@/views/login.vue'),
            meta: {
                title: '登录',
                breadcrumb: false
            }
        }
    ]
  },
  {
    path: '/:all(.*)*',
    name: 'notFound',
    component: () => import('@/views/[...all].vue'),
    meta: {
      title: '找不到页面',
    }
  },
  {
      path: '/join/:invite_id?',
      name: 'join',
      component: () => import('@/views/join/index.vue'),
      meta: {
          title: '申请入驻'
      }
  },
  {
      path: '/creation_camp_contact',
      name: 'creationCampContact',
      component: () => import('@/views/creation_camp/contact_progress.vue'),
      meta: {
          title: '合同进度'
      }
  },
  {
      path: '/creation_camp_contact_welfare',
      name: 'creationCampContactWelfare',
      component: () => import('@/views/creation_camp/contact_progress_welfare.vue'),
      meta: {
          title: '合同进度'
      }
  },
  {
    path: '/creation_camp_contact_mainBusiness',
    name: 'creationCampContactMainBusiness',
    component: () => import('@/views/creation_camp/contact_progress_mainbusiness.vue'),
    meta: {
        title: '合同进度'
    }
  }
]

// 系统路由
const systemRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('@/layouts/index.vue'),
    meta: {
      title: () => useSettingsStore().settings.home.title,
      breadcrumb: false,
    },
    children: [
      {
        path: '',
        component: () => import('@/views/index.vue'),
        meta: {
          title: () => useSettingsStore().settings.home.title,
          icon: 'i-ant-design:home-twotone',
          breadcrumb: false,
        },
      },
      {
        path: 'reload',
        name: 'reload',
        component: () => import('@/views/reload.vue'),
        meta: {
          title: '重新加载',
          breadcrumb: false,
        },
      },
      {
        path: 'user/setting',
        name: 'userSetting',
        component: () => import('@/views/user/setting.vue'),
        meta: {
          title: '个人设置'
        },
      }
    ],
  },
]

// 动态路由（异步路由、导航栏路由）
const asyncRoutes: Route.recordMainRaw[] = [
  {
    meta: {
      title: '主页',
      icon: 'i-uim:box'
    },
    children: [
      Merchant,
      YearFrame,
      Business,
      Welfare,
      CreationCamp,
      RegimentalCommander,
      MerchantManage,
      MainBusiness,
      // Task,
      Setups,
      
    ],
  }
]

const constantRoutesByFilesystem = generatedRoutes.filter((item) => {
  return item.meta?.enabled !== false && item.meta?.constant === true
})

const asyncRoutesByFilesystem = setupLayouts(generatedRoutes.filter((item) => {
  return item.meta?.enabled !== false && item.meta?.constant !== true && item.meta?.layout !== false
}))

export {
  constantRoutes,
  systemRoutes,
  asyncRoutes,
  constantRoutesByFilesystem,
  asyncRoutesByFilesystem,
}
